import { Account, AccountLight } from "../../../../services/cloudchipr.api";

export const convertAccountToAccountLight = (
  account: Account,
): AccountLight => {
  return {
    id: account.id,
    provider: account.type,
    provider_account_id: account.provider_account_id ?? "",
    provider_account_name: account.provider_account_name ?? "",
    provider_access_type: account.access_type,
    filter_set_id: account.filter_set_id,
  };
};
